import { ColumnsConfig } from 'components/shared/data/DataGrid/DataGrid.types';
import { RecipientGroup, SynchronizedInstitution } from 'store/polls';
import { recipientGroupSlug } from 'utils/i18n/recipientGroup';

// Checkbox column is provided by AG Grid when rowSelection='multiple' (no need for explicit column)
export const institutionsColumns: ColumnsConfig<SynchronizedInstitution, void> = () => {
  return [
    {
      field: 'name',
      name: 'POLLS.PUBLICATION.INSTITUTIONS.NAME_COLUMN',
      columnParams: { flex: 1 },
    },
  ];
};

// Checkbox column is provided by AG Grid when rowSelection='multiple' (no need for explicit column)
export const recipientsGroupsColumns: ColumnsConfig<RecipientGroup, void> = () => {
  return [
    {
      field: 'name',
      name: 'POLLS.PUBLICATION.RECIPIENT_GROUPS.NAME_COLUMN',
      columnParams: { flex: 1 },
      format: (data, trans) => {
        return trans(recipientGroupSlug(data.name));
      },
    },
  ];
};
